import { Getter } from 'vuex'
import { IState } from './state'

const hits: Getter<IState, IState> = state => state.hits
const total: Getter<IState, IState> = state => state.total
const categoryFilters: Getter<IState, IState> = state => state.categoryFilters
const pages: Getter<IState, IState> = state => state.pages
const page: Getter<IState, IState> = state => state.page
const getParams: Getter<IState, IState> = state => {
	const filters = JSON.stringify(
		state.categoryFilters.map(cf => {
			return {
				identifier: cf.identifier,
				values: cf.values.filter(v => v.selected).map(v => v.value)
			}
		})
	)
	const sort = JSON.stringify(state.sort.find(s => s.active))

	const dateStart = state.date.start && new Date(state.date.start).getTime()
	const dateEnd = state.date.end && new Date(state.date.end).getTime()

	const params = {
		query: state.query,
		page: state.page,
		dateStart,
		dateEnd,
		filters,
		sort
	}

	return params
}
const hasFilters: Getter<IState, IState> = state => {
	const categoryFiltersCount = state.categoryFilters.reduce((acc, curr) => {
		return acc + curr.values.filter(v => v.selected).length
	}, 0)
	const categoryFilterIsSet = categoryFiltersCount > 0
	const dateFilterIsSet = state.date.start + state.date.end !== ''

	return categoryFilterIsSet || dateFilterIsSet
}
const title: Getter<IState, IState> = state => state.title
const description: Getter<IState, IState> = state => state.description
const sorts: Getter<IState, IState> = state => state.sort
const date: Getter<IState, IState> = state => state.date
const query: Getter<IState, IState> = state => state.query
const extraLinks: Getter<IState, IState> = state => state.extraLinks
const searchedQuery: Getter<IState, IState> = state => state.searchedQuery
const suggestions: Getter<IState, IState> = state => state.suggestions.items
const showSuggestions: Getter<IState, IState> = state => state.suggestions.show

export default {
	hits,
	total,
	categoryFilters,
	pages,
	page,
	getParams,
	hasFilters,
	title,
	description,
	sorts,
	date,
	query,
	extraLinks,
	searchedQuery,
	suggestions,
	showSuggestions
}
